import React from 'react';
import { Container } from './ui/Container';
import { BookOpenIcon, MailIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-navy-900 text-brand-cream-100 pt-16 pb-8 border-t border-white/10" data-id="element-24">
      <Container data-id="element-25">
        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-26">
          <div className="col-span-1 md:col-span-2" data-id="element-27">
            <div className="flex items-center gap-2 mb-6" data-id="element-28">
              <div className="bg-brand-amber-500 p-2 rounded-lg text-white" data-id="element-29">
                <BookOpenIcon size={24} data-id="element-30" />
              </div>
              <span className="text-xl font-bold text-white" data-id="element-31">TGT FLIP</span>
            </div>
            <p className="text-brand-cream-100/70 mb-6 max-w-sm" data-id="element-32">
              Plataforma de recursos educativos digitales operada por TGT FLIP
              LLC. Ayudamos a docentes a optimizar su tiempo con materiales de
              calidad.
            </p>
          </div>

          <div data-id="element-33">
            <h4 className="text-white font-bold mb-6" data-id="element-34">Legal</h4>
            <ul className="space-y-3 text-sm text-brand-cream-100/70" data-id="element-35">
              <li data-id="element-36">
                <a href="#" className="hover:text-brand-amber-500 transition-colors" data-id="element-37">
                  Términos de Uso
                </a>
              </li>
              <li data-id="element-38">
                <a href="#" className="hover:text-brand-amber-500 transition-colors" data-id="element-39">
                  Política de Privacidad
                </a>
              </li>
              <li data-id="element-40">
                <a href="#" className="hover:text-brand-amber-500 transition-colors" data-id="element-41">
                  Política de Reembolso
                </a>
              </li>
            </ul>
          </div>

          <div id="contacto" data-id="element-42">
            <h4 className="text-white font-bold mb-6" data-id="element-43">Contacto</h4>
            <ul className="space-y-4 text-sm text-brand-cream-100/70" data-id="element-44">
              <li className="flex items-start gap-3" data-id="element-45">
                <MailIcon className="w-5 h-5 text-brand-amber-500 flex-shrink-0" data-id="element-46" />
                <span data-id="element-47">tgtflipllc@activapleno.com</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-48">
                <MapPinIcon className="w-5 h-5 text-brand-amber-500 flex-shrink-0" data-id="element-49" />
                <span data-id="element-50">
                  1209 Mountain Road Place Northeast,
                  <br data-id="element-51" />
                  Albuquerque, NM 87110,
                  <br data-id="element-52" />
                  United States
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 text-center text-sm text-brand-cream-100/40" data-id="element-53">
          <p data-id="element-54">
            &copy; {new Date().getFullYear()} TGT FLIP LLC. Todos los derechos
            reservados.
          </p>
        </div>
      </Container>
    </footer>;
}